import * as moment from "moment/moment";

export interface IPatient {
  id: number;
  full_name: string;
  birthdate: moment.Moment | null;
  gic: number;
  ra: number;
  mco_name: string;
}
export interface SortOption {
  field: string;
  order: 'asc' | 'desc';
}
export class Patient {
  id: number;
  fullName: string;
  birthDate: moment.Moment | null;
  gic: number;
  ra: number;
  mcoName: string;

  constructor(data?: IPatient) {
    this.id = data?.id ?? 0;
    this.fullName = data?.full_name ?? '';
    this.birthDate = data?.birthdate ?? null ;
    this.gic = data?.gic ?? 0;
    this.ra = data?.ra ?? 0;
    this.mcoName = data?.mco_name ?? '';
  }

  static fromObjectArray(patients: IPatient[]): Patient[] {
    return patients.map(patient => new Patient(patient));
  }
}

export interface IResultPatient {
  count: number;
  next: string;
  previous: string | null;
  results: IPatient[];
}

export class ResultPatient {
  count: number = 0;
  next: string = '';
  previous: string | null = null;
  results: Patient[] = [];

  constructor(result?: IResultPatient) {
    if (result) {
      this.count = result.count ?? 0;
      this.next = result.next ?? '';
      this.previous = result.previous ?? null;
      this.results = Patient.fromObjectArray(result.results ?? []);
    }
  }
}
